import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleAdd.svg",
  "use": "CircleAdd.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleAdd.svg\"><path d=\"M32.01,56.0209a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0209Zm0-44.0009A20.0009,20.0009,0,1,0,52.0113,32.0209,20.0008,20.0008,0,0,0,32.01,12.02Zm2,33.0008a2,2,0,1,1-4,0v-11h-11a2,2,0,0,1,0-4h11v-11a2,2,0,1,1,4,0v11h11a2,2,0,0,1,0,4h-11Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol